export default "__VITE_ASSET__aa71ccae__"